import { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "react-use";
import Swal from "sweetalert2";
import useSharedData from "../../hooks/useSharedData";
import FooterPostup from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import CompanySection from "./components/CompanySection";
import HeaderSection from "./components/HeaderSection";
import SenderAddress from "./components/SenderAddress";
import ShipmentSectionAvaShop from "./components/Shipments/ShipmentSectionAvaShop";

const Shop = () => {
  const navigate = useNavigate();

  const [company, setCompany] = useSessionStorage("company", {
    selected: {},
    value: -1,
  });

  const { hasAccess } = useSharedData();

  const [senderAddress, setSenderAddress] = useSessionStorage("SAddress", {});

  useEffect(() => {
    if (hasAccess(1) === false) {
      Swal.fire({
        icon: "error",
        title: "به این سرویس دسترسی ندارید",
        text: "برای دریافت اطلاعات بیشتر با پشتیبانی تماس حاصل فرمایید",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      }).then(() => {
        navigate("/");
      });
    }
  }, []);

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 rtl-all content-box py-3">
        <HeaderSection />
        <SenderAddress state={{ senderAddress, setSenderAddress }} />
        <CompanySection state={{ company, setCompany }} />
        <ShipmentSectionAvaShop
          company={company}
          senderAddress={senderAddress}
        />
      </main>
      <FooterPostup />
    </Fragment>
  );
};

export default Shop;
